import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useDocumentParams } from "./useDocumentParams";

export function useDocumentDetails() {
    const navigate = useStateAwareNavigate();
    const { documentId } = useDocumentParams();
    return {
        shownDocumentId: documentId ? Number(documentId) : null,
        showDocumentDetails: (financialDocumentId: number) => {
            navigate(`/documents/${financialDocumentId}`);
        },
        closeDetails: () => {
            navigate("/documents");
        },
    };
}
